import React from "react";
import { canUseDOM } from "exenv";
import { configure } from "mobx";
import { Provider } from "mobx-react";
import "mobx-react/batchingForReactDom";

configure({ enforceActions: "observed" });

const withUniversalStore = (
  rootStoreInstance,
  createRootStoreInstance
) => Component => {
  class WithInitialization extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        store: canUseDOM ? rootStoreInstance : createRootStoreInstance()
      };

      this.state.store.initialize(props);
    }

    render() {
      return (
        <Provider store={this.state.store}>
          <Component {...this.props} />
        </Provider>
      );
    }
  }

  return WithInitialization;
};

export default withUniversalStore;
